import { g as getRoomType } from './get-room-type.js';
import './index2.js';

/**
 * Previo
 */
const factory = function factory({ window, document, thn }) {
    const roomDetailsParseData = (numAdults, nights) => {
        const roomsArray = Array.from(document.querySelectorAll('.room'));
        if (thn.empty(roomsArray)) {
            return [];
        }
        const roomsInfo = roomsArray.map((room) => {
            const roomName = room.querySelector('.heading.open-room-detail')?.textContent?.trim();
            const roomType = getRoomType(roomName);
            const ratesInfo = Array.from(room.querySelectorAll('.occupancy-row')).map((rate) => {
                const rateName = '';
                const ratePrice = thn.parseNumber(rate.querySelector('.new-price')?.textContent);
                const hasBreakfast = false;
                const isRefundable = true;
                if (!ratePrice) {
                    return null;
                }
                return {
                    name: rateName,
                    totalNight: ratePrice / nights,
                    breakfast: hasBreakfast,
                    refundable: isRefundable,
                };
            }).filter((value) => value !== null);
            if (!roomName) {
                return null;
            }
            return {
                name: roomName,
                adults: numAdults || 2,
                children: 0,
                type: roomType,
                rates: ratesInfo,
                prices: ratesInfo,
            };
        });
        return roomsInfo.filter((value) => value !== null);
    };
    return {
        isUserLogged() {
            const isLogged = false;
            return isLogged;
        },
        languageCheck(ctx) {
            return new Promise((resolve, reject) => {
                const lang = thn.parseUrlParameter('lang');
                if (lang && ctx.langs.test(lang)) {
                    resolve(lang);
                    return;
                }
                reject(new Error('no_language'));
            });
        },
        onStateChange() {
            thn.debounce(thn.pageCheck, 800)();
        },
        priceParseData() {
            // Guests, Adults & Children
            const ratesInfo = Array.from(document.querySelectorAll('.occupancy-row'))
                .map((rate) => {
                const adults = rate.querySelectorAll('.occupancy i').length || 1;
                const children = 0;
                const price = thn.parseNumber(rate.querySelector('.new-price')?.textContent) ?? 0;
                return {
                    price,
                    adults,
                    children,
                };
            }).sort((a, b) => (a.price ?? 0) - (b.price ?? 0));
            // Dates
            const dateBegin = document.querySelector('[name="arrival"]')?.value?.replace(/-/g, '/') ?? '';
            const dateEnd = document.querySelector('[name="departure"]')?.value?.replace(/-/g, '/') ?? '';
            const nights = dateBegin && dateEnd ? thn.daysBetween(dateBegin, dateEnd) : 0;
            if (!dateBegin || !dateEnd) {
                return null;
            }
            // Prices & Currency || No Rooms
            const currency = thn.parseCurrency(document.querySelector('.new-price .value')?.textContent);
            if (!thn.empty(ratesInfo) && currency) {
                return {
                    adults: ratesInfo[0].adults,
                    children: ratesInfo[0].children,
                    dateBegin,
                    dateEnd,
                    price: ratesInfo[0].price / nights,
                    currency,
                    roomDetails: roomDetailsParseData(ratesInfo[0].adults, nights),
                };
            }
            if (thn.empty(ratesInfo)) {
                return {
                    adults: ratesInfo[0].adults,
                    children: ratesInfo[0].children,
                    currency,
                    dateBegin,
                    dateEnd,
                    noRooms: true,
                };
            }
            return null;
        },
        bookingParseData() {
            const bookingData = thn.dataLayerHelper.get('ecommerce');
            // Booking ID
            const bookingId = bookingData?.transaction_id;
            if (!bookingId) {
                return {
                    set: false,
                };
            }
            // Dates
            const dates = bookingData?.items?.[0]?.item_variant?.split('/') ?? [];
            const dateBegin = dates[0]?.replace(/-/g, '/') ?? '';
            const dateEnd = dates[1]?.replace(/-/g, '/') ?? '';
            // Price & Currency
            const price = thn.parseNumber(bookingData?.value?.toString());
            const currency = thn.parseCurrency(bookingData?.currency?.toString());
            return {
                bookingId,
                dateBegin,
                dateEnd,
                price,
                currency,
            };
        },
    };
};

export { factory };
